import React, { useEffect, useState } from 'react';
import { learnerApi } from '../../api/client';
import { useAuth } from '../../context/AuthContext';
import Spinner from '../../components/common/Spinner';
import { FaSchool, FaChalkboard } from 'react-icons/fa';

const SCOPE_STYLE = {
  school: { label:'School',       color:'#6b7280', icon: FaSchool,    bg:'#f3f4f6' },
  class:  { label:'Your Class',   color:'#0d6efd', icon: FaChalkboard, bg:'#eff6ff' },
  parent: { label:'Class',        color:'#10b981', icon: FaChalkboard, bg:'#f0fdf4' },
};

export default function LearnerNotices() {
  const { school }  = useAuth();
  const primary     = school?.primary_color || '#0d6efd';
  const [notices,   setNotices]   = useState([]);
  const [loading,   setLoading]   = useState(true);
  const [filter,    setFilter]    = useState('all'); // all | school | class

  useEffect(() => {
    learnerApi.getNotices()
      .then(r => setNotices(Array.isArray(r.data?.data) ? r.data.data : []))
      .finally(() => setLoading(false));
  }, []);

  const filtered = filter === 'all' ? notices
    : filter === 'class' ? notices.filter(n => n.scope === 'class' || n.scope === 'parent')
    : notices.filter(n => n.scope === 'school' || !n.scope);

  const classCount  = notices.filter(n => n.scope === 'class' || n.scope === 'parent').length;
  const schoolCount = notices.filter(n => n.scope === 'school' || !n.scope).length;

  return (
    <div>
      <div className="page-header">
        <h2>Notices</h2>
        <p>{notices.length} active notice{notices.length !== 1 ? 's' : ''}</p>
      </div>

      {/* Filter tabs */}
      <div style={{ display:'flex', gap:8, marginBottom:20, flexWrap:'wrap' }}>
        {[
          { key:'all',    label:`All (${notices.length})`,          color:'#374151' },
          { key:'class',  label:`My Class (${classCount})`,         color:'#0d6efd' },
          { key:'school', label:`School-wide (${schoolCount})`,     color:'#6b7280' },
        ].map(t => (
          <button key={t.key} onClick={() => setFilter(t.key)}
            className="sms-btn"
            style={{
              background: filter === t.key ? t.color : '#fff',
              color:      filter === t.key ? '#fff'   : t.color,
              border:     `1px solid ${t.color}44`,
              padding:    '7px 16px',
            }}>
            {t.label}
          </button>
        ))}
      </div>

      {loading ? <Spinner /> : (
        <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
          {filtered.map(n => {
            const scope = SCOPE_STYLE[n.scope] || SCOPE_STYLE.school;
            const borderColor = n.is_pinned ? '#f59e0b' : scope.color;
            return (
              <div key={n.notice_id} className="sms-card"
                style={{ borderLeft:`4px solid ${borderColor}`, background: n.scope === 'class' || n.scope === 'parent' ? scope.bg : '#fff' }}>
                {/* Header row */}
                <div style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', marginBottom:8 }}>
                  <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'wrap' }}>
                    {n.is_pinned && (
                      <span style={{ fontSize:'0.7rem', background:'#fef3c7', color:'#92400e', padding:'2px 8px', borderRadius:12, fontWeight:700 }}>
                        📌 PINNED
                      </span>
                    )}
                    <span style={{ display:'inline-flex', alignItems:'center', gap:5, fontSize:'0.72rem',
                      background:`${scope.color}18`, color:scope.color, padding:'2px 9px', borderRadius:12, fontWeight:600 }}>
                      <scope.icon size={10} /> {scope.label}
                    </span>
                    {n.grade_number && (
                      <span style={{ fontSize:'0.72rem', background:`${primary}18`, color:primary, padding:'2px 8px', borderRadius:12, fontWeight:600 }}>
                        Grade {n.grade_number}
                      </span>
                    )}
                  </div>
                  <span style={{ fontSize:'0.75rem', color:'#9ca3af', flexShrink:0, marginLeft:10 }}>
                    {new Date(n.created_at).toLocaleDateString()}
                  </span>
                </div>

                <h5 style={{ fontWeight:700, margin:'0 0 8px', fontSize:'1rem' }}>{n.title}</h5>
                <p style={{ color:'#4b5563', lineHeight:1.7, margin:'0 0 10px', fontSize:'0.9rem' }}>{n.body}</p>

                <div style={{ display:'flex', gap:16, fontSize:'0.75rem', color:'#9ca3af' }}>
                  <span>By {n.author_name}</span>
                  {n.start_date && <span>{n.start_date}{n.end_date ? ` → ${n.end_date}` : ''}</span>}
                </div>
              </div>
            );
          })}

          {filtered.length === 0 && (
            <div className="sms-card" style={{ textAlign:'center', color:'#9ca3af', padding:'60px 0' }}>
              No {filter !== 'all' ? filter : ''} notices at the moment
            </div>
          )}
        </div>
      )}
    </div>
  );
}
